<template>
  <v-card :style="backOpacity">
    <v-card-title>送信ボタンフォーム SendButtonForm.vue</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="auto">
              <v-text-field
                label="ラベル"
                v-model="returnData.label"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="returnData.cols">
              <v-text-field
                label="サイズ"
                v-model="returnData.cols"
                :rules="[varidation.cols]"
              ></v-text-field>
              *6以上でスクロール形式の場合ボタンが大きくなる
            </v-col>
          </v-row>
          <v-row>
            <!--
            <v-col cols="12">
              <v-radio-group label="ユーザ制限" v-model="rules[5]" row>
                <v-radio label="全て" value="0"></v-radio>
                <v-radio label="一般のみ" value="null"></v-radio>
                <v-radio label="管理者のみ" value="admin"></v-radio>
                <v-radio label="その他のみ" value="other"></v-radio>
              </v-radio-group>
            </v-col>
            -->
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-radio-group label="ボタンの固定" v-model="rules[4]">
                <v-radio label="下部に固定" value="0"></v-radio>
                <v-radio label="スクロールに連動する" value="1"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-checkbox
                label="非表示"
                v-model="rules[21]"
                value="true"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <!---------特定フォームに値を保存---------------------- ---->
            <v-row>
              <v-col cols="4">
                <v-checkbox
                  v-model="rules[2]"
                  value="true"
                  label="特定フォームに値を保存"
                ></v-checkbox>
              </v-col>
              <v-col cols="1">
                <v-btn v-if="rules[2] == 'true'" @click="addTarget" class="ma-2"
                  >追加</v-btn
                >
              </v-col>
              <v-col cols="1">
                <v-btn v-if="rules[2] == 'true'" @click="delTarget" class="ma-2"
                  >削除</v-btn
                >
              </v-col>
              <v-col
                class="ma-2"
                cols="2"
                v-if="rules[2] == 'true' && rules[7] == 'true'"
              >
                <v-text-field
                  label="サブページのformID"
                  v-model="rules[8]"
                  :rules="[varidation.numonly]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <div
              v-for="(target, j) in targetIDs"
              :key="`sensor-${j}`"
              class="mb-4"
            >
              <v-row v-if="rules[2] == 'true'">
                <v-col cols="1">
                  <v-text-field
                    :label="
                      targetSaveValus[j] == 'SendMail' ? 'pageID' : 'formID'
                    "
                    :rules="[varidation.numonly]"
                    v-model="targetIDs[j]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-select
                    :items="saveType"
                    v-model="targetSaveValus[j]"
                    item-text="text"
                    item-value="value"
                    label="保存データ"
                    :rules="[varidation.required]"
                  ></v-select>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    :label="
                      targetSaveValus[j] == 'SendMail'
                        ? '条件対象フォームID(.区切り)'
                        : '条件対象フォームID'
                    "
                    :rules="[]"
                    v-model="targetTarmsID[j]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="if == X"
                    :rules="[]"
                    v-model="targetTarmsValue[j]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="2"
                  v-if="
                    targetSaveValus[j] == 'target' ||
                      targetSaveValus[j] == 'formID' ||
                      targetSaveValus[j] == 'formIDadd' ||
                      targetSaveValus[j] == 'formIDaddDuplicate'
                  "
                >
                  <v-text-field
                    :label="
                      targetSaveValus[j] == 'target' ? '固定値' : 'formID'
                    "
                    :rules="[]"
                    v-model="targetValues[j]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <!---元データ------------------------------------------------------
            <v-col cols="3">
              <v-checkbox
                v-model="rules[2]"
                value="true"
                label="特定フォームに値を保存"
              ></v-checkbox>
            </v-col>
            <v-col cols="2" v-if="rules[2] == 'true'">
              <v-text-field
                label="formID"
                :rules="[varidation.numonly]"
                v-model="rules[3]"
                required
              ></v-text-field>
            </v-col>
            --->
          </v-row>
          <hr />
          <v-row>
            <v-col cols="6">
              <v-radio-group label="保存データ" v-model="rules[0]" row>
                <v-radio label="時刻" value="0"></v-radio>
                <v-radio label="固定値" value="1"></v-radio>
                <v-radio label="特定フォームの値" value="2"></v-radio>
                <v-radio label="何も保存しない" value="3"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="4" v-if="rules[0] == '1'">
              <v-text-field
                label="初期値"
                v-model="returnData.init"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4" v-else-if="rules[0] == '2'">
              <v-text-field
                label="特定フォームID ※同一ページのみ指定可"
                v-model="returnData.init"
                required
                :rules="[varidation.numonly]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-checkbox
                v-model="rules[1]"
                value="true"
                label="全てのバリデーションを判定しない"
              ></v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                v-model="rules[10]"
                value="true"
                label="ページを戻らない"
                :disabled="rules[25] == 'true'"
              ></v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                v-model="rules[25]"
                value="true"
                label="送信後コピー処理を実行"
                :disabled="rules[10] == 'true'"
              ></v-checkbox
              >copyボタンフォーム必須
            </v-col>
          </v-row>
          <!------------------------------- ---->
          <v-row>
            <v-col cols="2">
              <v-checkbox v-model="rules11Flag" label="メール送信"></v-checkbox>
            </v-col>
            <v-col v-if="rules11Flag" cols="3">
              <v-text-field
                label="検索条件FormID(.区切り)"
                :rules="[]"
                v-model="mailSend[0]"
                required
              ></v-text-field>
            </v-col>
            <v-col v-if="rules11Flag" cols="5">
              <v-text-field
                label="条件値(.区切り)"
                :rules="[]"
                v-model="mailSend[1]"
                required
              ></v-text-field>
            </v-col>
            <v-col v-if="rules11Flag" cols="2">
              <v-text-field
                label="ユーザ情報ページの検索対象"
                :rules="[varidation.numonly]"
                v-model="mailSend[2]"
                required
              ></v-text-field>
            </v-col>
            <v-col v-if="rules11Flag" cols="6">
              <v-text-field
                label="メールに設定する固定値(;区切り)"
                v-model="mailSend[3]"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-checkbox
                v-model="rules17Flag"
                label="サブページの特定フォームの重複チェック"
              ></v-checkbox>
            </v-col>
            <v-col cols="2" v-if="rules17Flag">
              <v-text-field
                label="サブページformID"
                v-model="rules17subpageFormID"
                :rules="[varidation.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="2" v-if="rules17Flag">
              <v-text-field
                label="対象formID"
                v-model="rules17formID"
                :rules="[varidation.required]"
              ></v-text-field>
            </v-col>
          </v-row>
          <!------------------------------- ---->
          <v-row>
            <v-col cols="4">
              <v-checkbox
                v-model="rules[6]"
                value="true"
                label="クリック権限制御"
              ></v-checkbox>
            </v-col>

            <!--
            <v-col cols="2" v-if="rules[6] == 'true'">
              <v-text-field
                label="formID"
                :rules="[varidation.numonly]"
                v-model="rules[7]"
                required
              ></v-text-field>
            </v-col>
            -->
            <v-col cols="1" v-if="rules[6] == 'true'">
              <v-btn @click="addTerm" class="ma-2">追加</v-btn>
            </v-col>
            <v-col cols="1" v-if="rules[6] == 'true'">
              <v-btn @click="delTerm" class="ma-2">削除</v-btn>
            </v-col>
          </v-row>
          <!----押下条件---------------------------------->
          <div v-if="rules[6]">*条件を満たす場合のみクリック可</div>
          <div
            v-for="(targetFormID, i) in targetFormIDs"
            :key="`6-${i}`"
            class="mb-4"
          >
            <v-row v-if="rules[6]">
              <v-col cols="2" v-if="i != 0">
                <v-select
                  label="AndOr"
                  v-model="termAndOr[i]"
                  :items="termAndOrSelect"
                ></v-select>
              </v-col>
              <v-col cols="2" v-else> </v-col>
              <v-col cols="3">
                <v-select
                  label="条件"
                  v-model="termTypes[i]"
                  item-text="label"
                  item-value="value"
                  :items="termTypeSelect"
                ></v-select>
              </v-col>
              <v-col
                cols="3"
                v-if="termTypes[i] == 'uuID' || termTypes[i] == 'name'"
              >
                <v-text-field
                  label="formID"
                  hint="先頭に!を付けると条件式を!=として判定します"
                  :rules="[varidation.numOrEx]"
                  v-model="targetFormIDs[i]"
                ></v-text-field>
              </v-col>
              <v-col cols="3" v-else>
                <v-text-field
                  :label="
                    termTypes[i] == 'role' || termTypes[i] == 'roleEqual'
                      ? 'role'
                      : 'formID'
                  "
                  :rules="[varidation.required]"
                  v-model="targetFormIDs[i]"
                ></v-text-field>
              </v-col>

              <v-col
                cols="3"
                v-if="termTypes[i] == 'formID' || termTypes[i] == 'userFormID'"
              >
                <v-text-field
                  label="if == X"
                  hint="先頭に!を付けると!=として評価します"
                  :rules="[]"
                  v-model="termValues[i]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <!-------------------------------------->
          <v-row>
            <v-col cols="4">
              <v-checkbox
                v-model="rules24Flag"
                label="送信時重複チェック"
              ></v-checkbox>
            </v-col>
            <v-col cols="4" v-if="rules24Flag">
              <v-text-field
                label="メッセージを記入"
                v-model="rules[24]"
                hint="同一ページのチェック対象.メッセージ内容"
                persistent-hint
              ></v-text-field>
            </v-col>
          </v-row>
          <!-------------------------------------->
          <v-row>
            <v-col>
              <v-select
                :items="colors"
                v-model="returnData.color"
                label="ボタンの色"
                :rules="[varidation.required]"
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                :items="textColors"
                item-text="label"
                item-value="value"
                v-model="textColor"
                label="テキストの色"
              ></v-select
            ></v-col>
          </v-row>
          {{ rules }}
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :color="returnData.color + ' ' + textColor"
        v-show="showButton"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        fixed
        bottom
        right
        x-large
        class="mr-10 mb-8"
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    //共通値
    type: Number,
    position: Number,
    label: String,
    cols: String,
    //個別値
    init: String,
    color: String,
    rule: String,
  },
  data() {
    return {
      returnData: {
        //共通値
        type: this.type,
        position: this.position,
        label: this.label,
        cols: this.cols,
        //個別値
        init: this.init,
        rule: this.rule,
        color: this.color,
      },
      backOpacity: "opacity: 1",
      showButton: false,
      rules: [0, 0, 0, "", "1", null, null, ""],
      targetFormIDs: [0],
      termAndOr: ["or"],
      termTypes: ["role"],
      termAndOrSelect: ["and", "or"],
      termTypeSelect: [
        { label: "特定フォーム値が空でない", value: "formIDNotNull" },
        { label: "特定フォーム値が空の時", value: "formIDisNull" },
        { label: "ユーザ権限 !=", value: "role" },
        { label: "ユーザ権限 ==", value: "roleEqual" },
        { label: "特定フォーム値", value: "formID" },
        { label: "ユーザ設定ページの追加フォーム", value: "userFormID" },
        { label: "自身のuuIDと比較", value: "uuID" },
        { label: "自身の名前と比較", value: "name" },
      ],
      //特定フォームに値を保存
      targetIDs: [0], //rules[12]
      targetSaveValus: ["0"], //rules[13]
      targetValues: [""], //rules[14]
      targetTarmsID: [""], //rules[15]
      targetTarmsValue: [""], //rules[16]
      rules17Flag: false,
      rules17subpageFormID: 0,
      rules17formID: 0,
      saveType: [
        { text: "日時", value: "date" },
        { text: "時刻", value: "time" },
        { text: "固定値", value: "target" },
        { text: "削除", value: "delete" },
        { text: "ユーザ名", value: "userName" },
        { text: "特定フォームの値", value: "formID" },
        { text: "特定フォーム追記(,)", value: "formIDadd" },
        { text: "特定フォーム追記(,)重複無し", value: "formIDaddDuplicate" },
        { text: "メール送信(作成中)", value: "SendMail" },
      ],
      //押下条件
      clickTerms: ["role"], //rules[18]
      clickTermValues: ["0"], //rules[19]
      clickTermCondition: ["状態A"], //rules[20]
      joinTerms: ["OR"], //rules[23]
      joinTerm: ["AND", "OR", "AND(", "OR(", "AND)", "OR)"],
      selectclickTerms: [
        { label: "ユーザ権限", value: "role" },
        { label: "特定フォーム値", value: "formID" },
        { label: "ユーザ情報の特定フォーム値", value: "UserformID" },
        { label: "特殊関数", value: "special" },
      ],
      selectRole: [
        { label: "一般", value: "0" },
        { label: "管理者", value: "1" },
        { label: "第3属性", value: "2" },
      ],

      //メール送信設定
      mailSend: ["0.0", "グループ情報.アクション名", "0"],
      termValues: ["X"],
      //
      select: ["on", "off"],
      colors: [
        "primary",
        "yellow",
        "red",
        "blue",
        "yellow lighten-4",
        "blue-grey darken-1",
        "orange",
        "deep-orange",
      ],
      textColor: "",
      textColors: [
        { label: "black", value: "" },
        { label: "white", value: "white--text" },
      ],
      rules11Flag: false,
      rules24Flag: false,
      //バリデーション
      valid: true,
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        numOrEx: (value) => {
          return /^!?[0-9]*$/.test(value) || "!数値, 数値 のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        required: (value) => !!value || "必須項目です",
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.showButton = true;
    }, 500);

    this.rules = this.rule.split(",");
    [this.returnData.color, this.textColor] = this.color.split(",");
    if (this.rules[6] == "true") {
      this.targetFormIDs = this.rules[7].split(":");
      this.termTypes = this.rules[8].split(":");
      this.termValues = this.rules[9].split(":");
      this.termAndOr = this.rules[22].split(":");
    }
    if (this.rules[2] == "true") {
      this.rules[3] = "0";
      this.targetIDs = this.rules[12].split(":");
      this.targetSaveValus = this.rules[13].split(":");
      this.targetValues = this.rules[14].split(":");
      this.targetTarmsID = this.rules[15].split(":");
      this.targetTarmsValue = this.rules[16].split(":");
    }

    if (this.rules[11] == undefined) {
      this.rules[11] = "";
    }
    if (this.rules[11] != null && this.rules[11] != "") {
      this.rules11Flag = true;
      this.mailSend = this.rules[11].split(":");
    }
    if (this.nullCheck(this.rules[17])) {
      this.rules17Flag = true;
      [this.rules17subpageFormID, this.rules17formID] = this.rules[17].split(
        "."
      );
    }
    if (this.rules[24] != null && this.rules[24] != "") {
      this.rules24Flag = true;
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        if (this.rules[0] == "0") {
          this.returnData.init = "";
        }
        //送信ボタンオプション
        if (this.rules[2] != "true") {
          this.rules[3] = "";
          this.rules[12] = "";
          this.rules[13] = "";
          this.rules[14] = "";
          this.rules[15] = "";
          this.rules[16] = "";
        } else {
          this.rules[3] = "0";
          this.rules[12] = this.targetIDs.join(":");
          this.rules[13] = this.targetSaveValus.join(":");
          this.targetSaveValus.forEach((v, i) => {
            if (
              v != "target" &&
              v != "formID" &&
              v != "formIDadd" &&
              v != "formIDaddDuplicate"
            ) {
              this.targetValues[i] = "";
            }
          });
          this.rules[14] = this.targetValues.join(":");
          this.rules[15] = this.targetTarmsID.join(":");
          this.rules[16] = this.targetTarmsValue.join(":");
        }
        if (this.rules[6] != "true") {
          this.rules[7] = "";
          this.rules[8] = "";
          this.rules[9] = "";
        } else {
          this.rules[7] = this.targetFormIDs.join(":");
          this.rules[8] = this.termTypes.join(":");
          this.rules[9] = this.termValues.join(":");
          this.rules[22] = this.termAndOr.join(":");
        }
        if (this.rules11Flag) {
          this.rules[11] = this.mailSend.join(":");
        } else {
          this.rules[11] = "";
        }
        if (this.rules17Flag) {
          this.rules[17] = this.rules17subpageFormID + "." + this.rules17formID;
        } else {
          this.rules[17] = "";
        }
        if (!this.rules24Flag) {
          this.rules[24] = "";
        }
        this.returnData.color += "," + this.textColor;
        this.returnData.rule = this.rules.join(",");
        this.$emit("clickSubmit", this.returnData);
      }
    },
    addTerm() {
      this.targetFormIDs.push(0);
      this.termAndOr.push("or");
      this.termTypes.push("role");
      this.termValues.push("");
    },
    delTerm() {
      this.targetFormIDs.splice(-1, 1);
      this.termAndOr.splice(-1, 1);
      this.termTypes.splice(-1, 1);
      this.termValues.splice(-1, 1);
    },
    addTarget() {
      if (this.targetIDs.length > 0) {
        let p = this.targetIDs.length - 1;
        this.targetIDs.push(this.targetIDs[p]);
        this.targetSaveValus.push(this.targetSaveValus[p]);
        this.targetValues.push(this.targetValues[p]);
        this.targetTarmsID.push(this.targetTarmsID[p]);
        this.targetTarmsValue.push(this.targetTarmsValue[p]);
      } else {
        this.targetIDs.push(0);
        this.targetSaveValus.push("0");
        this.targetValues.push("0");
        this.targetTarmsID.push("");
        this.targetTarmsValue.push("");
      }
    },
    delTarget() {
      this.targetIDs.splice(-1, 1);
      this.targetSaveValus.splice(-1, 1);
      this.targetValues.splice(-1, 1);
      this.targetTarmsID.splice(-1, 1);
      this.targetTarmsValue.splice(-1, 1);
    },
    /* 正常な値が入っていればtrue */
    nullCheck(value) {
      let checkFlag = true;
      switch (value) {
        case "":
        case "undefined":
        case null:
        case undefined:
        case false:
          checkFlag = false;
      }

      return checkFlag;
    },
  },
};
</script>
